import createClient from "openapi-fetch";

import { getBaseUrl } from "@/lib/env";

import { type TokenProvider, createAuthMiddleware } from "./auth-middleware";
import type { paths } from "./schema";

const createTokenProvider = (): TokenProvider => {
  return {
    getAccessToken: async () => {
      const { useAuthStore } = await import("@/lib/auth");
      return useAuthStore.getState().getAccessToken();
    },
  };
};

const apiClient = createClient<paths>({
  baseUrl: getBaseUrl(),
  credentials: "include",
});
const authMiddleware = createAuthMiddleware(createTokenProvider());
apiClient.use(authMiddleware);

export { apiClient };
